import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import Support from "./pages/Support";
import CopyrightPage from "./pages/Copyright";
import GivingPage from "./pages/Giving";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";

const container = document.querySelector("#root");
const root = createRoot(container);
const queryClient = new QueryClient();

const routes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/giving" element={<GivingPage />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/copyright" element={<CopyrightPage />} />
        <Route path="*" element={<div>404</div>} />
      </Routes>
    </Router>
  );
};

root.render(
  <QueryClientProvider client={queryClient}>{routes()}</QueryClientProvider>
);
